module.exports = __webpack_public_path__ + "img/maestro.5075c797.svg";